import { faPlus, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Button from 'components/base/Button';
import DatePicker from 'components/base/DatePicker';
import SearchBox from 'components/common/SearchBox';
import ClinicTable, {
  ClinicTableColumns
} from 'components/tables/superadmin/ClinicTable';
import ExportFoodDataModal from 'components/modals/ExportFoodDataModal';
import { errorHandler } from 'helpers/response-utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { ChangeEvent, useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { parseData } from 'helpers/utils';

const Clinics = () => {
  const nav = useNavigate();
  const [clinis, setClinis] = useState([]);
  const [showExportModal, setShowExportModal] = useState(false);
  const token = localStorage.getItem('token');
  const userJSON = localStorage.getItem('user');
  const currentUser = userJSON != null ? parseData(userJSON) : null;

  useEffect(() => {
    getClinicList();
  }, []);

  const getClinicList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_ENDPOINT}/clinic/sa`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (response.data['status'] == false) {
      errorHandler(response.data);
      return false;
    }

    setClinis(response.data['data']['clinics']);
  };

  const table = useAdvanceTable({
    data: clinis,
    columns: ClinicTableColumns,
    pageSize: 10,
    pagination: true,
    sortable: true,
    selection: false,
    initialState: {
      columnVisibility: {
        status: false,
        designation: false
      }
    }
  });
  const [openFilterModal, setOpenFilterModal] = useState(false);

  const handleSearchInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    table.setGlobalFilter(e.target.value || undefined);
  };

  const navigateToCreateClinic = () => {
    nav('/superadmin/clinic/add');
  };
  return (
    <div>
      <div className="mb-9">
        <AdvanceTableProvider {...table}>
          <h2 className="mb-4">{clinis.length} Clinics</h2>
          <Row className="g-3 justify-content-between mb-4">
            <Col xs="auto">
              <div className="d-flex gap-2">
                <Button
                  variant="primary"
                  className="me-0"
                  startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
                  onClick={navigateToCreateClinic}
                >
                  Add new clinic
                </Button>
                {currentUser?.role === 'superadmin' &&
                  (currentUser?.clinical_export_enabled ||
                    currentUser?.research_export_enabled) && (
                    <Button
                      variant="secondary"
                      startIcon={
                        <FontAwesomeIcon icon={faDownload} className="me-2" />
                      }
                      onClick={() => setShowExportModal(true)}
                    >
                      Export Data
                    </Button>
                  )}
              </div>
            </Col>
            <Col xs="auto">
              <div className="d-flex">
                <SearchBox
                  placeholder="Search by name"
                  className="me-2"
                  onChange={handleSearchInputChange}
                />
                <DatePicker defaultValue="Mar 1, 2022" />
              </div>
            </Col>
          </Row>
          <ClinicTable />
        </AdvanceTableProvider>
      </div>

      <ExportFoodDataModal
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
        userRole={currentUser?.role || 'superadmin'}
        userClinicalExportEnabled={
          currentUser?.clinical_export_enabled || false
        }
        userResearchExportEnabled={
          currentUser?.research_export_enabled || false
        }
      />
    </div>
  );
};

export default Clinics;
